module.exports = __webpack_public_path__ + "static/media/villa-azul-3.3b8a46c2.png";